
import React from 'react';
import { useFarmUpload } from './upload/useFarmUpload';
import FarmUploadPanel from './upload/FarmUploadPanel';
import FarmUploadStatus from './upload/FarmUploadStatus';
import FarmUploadInstructions from './upload/FarmUploadInstructions';

interface FarmUploadProps {
  onUploadComplete: () => void;
}

const FarmUpload: React.FC<FarmUploadProps> = ({ onUploadComplete }) => {
  const {
    file,
    isUploading,
    progress,
    uploadState,
    errors,
    parsedData,
    handleFileChange,
    handleUpload,
    downloadTemplate
  } = useFarmUpload(onUploadComplete);

  return (
    <div className="space-y-6">
      <FarmUploadPanel 
        file={file}
        isUploading={isUploading}
        handleFileChange={handleFileChange}
        handleUpload={handleUpload}
        downloadTemplate={downloadTemplate}
      />
      
      <FarmUploadStatus 
        isUploading={isUploading}
        progress={progress}
        uploadState={uploadState}
        errors={errors}
        parsedData={parsedData}
      />
      
      <FarmUploadInstructions />
    </div>
  );
};

export default FarmUpload;
